import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  NgModule,
  Renderer2,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Sort } from '../utils/sort';

@Directive({
  selector: '[lcmsSort]',
})
export class SortDirective {
  @Input() appSort: Array<any>;
  constructor(private renderer: Renderer2, private targetElem: ElementRef) {}

  @HostListener('click')
  sortData() {
    console.log("insid pipe",this.appSort);
    
    // Create Object of Sort Class
    const sort = new Sort();
    // Get Reference Of Current Clicked Element
    const elem = this.targetElem.nativeElement;
    // Get In WHich Order list should be sorted by default it should be set to desc on element attribute
    const order = elem.getAttribute('data-order');
    // Get The Property Type specially set [data-type=date] if it is date field
    const type = elem.getAttribute('data-type');
    // Get The Property Name from Element Attribute
    const property = elem.getAttribute('data-name');

    // Define arrow symbols
    const ascendingArrow = ' ↑';
    const descendingArrow = ' ↓';

    // Remove arrow symbol from all siblings
    const siblings = Array.from(elem.parentNode.children);
    siblings.forEach((sibling: any) => {
      if (sibling != elem && sibling.innerHTML.includes(ascendingArrow)) {
        sibling.innerHTML = sibling.innerHTML.replace(ascendingArrow, '');
      } else if (
        sibling != elem &&
        sibling.innerHTML.includes(descendingArrow)
      ) {
        sibling.innerHTML = sibling.innerHTML.replace(descendingArrow, '');
      }
    });

    if (order === 'desc') {
      this.appSort.sort(sort.startSort(property, order, type));
      elem.setAttribute('data-order', 'asc');
      // Remove any existing arrow symbol first
      if (elem.innerHTML.includes(ascendingArrow)) {
        elem.innerHTML = elem.innerHTML.replace(ascendingArrow, '');
      }
      elem.innerHTML += descendingArrow; // Append descending arrow to element


    } else {
      this.appSort.sort(sort.startSort(property, order, type));
      elem.setAttribute('data-order', 'desc');
      // Remove any existing arrow symbol first
      if (elem.innerHTML.includes(descendingArrow)) {
        elem.innerHTML = elem.innerHTML.replace(descendingArrow, '');
      }

      elem.innerHTML += ascendingArrow; // Append ascending arrow to element
    }
  }
}

@NgModule({
  imports: [CommonModule],
  declarations: [SortDirective],
  exports: [SortDirective],
})
export class SortDirectiveModule {}
